class Customer.ConversationAttributeTitleView extends Backbone.View
  template: JST['backbone/templates/customer/custom_attributes/conversation_attribute_title']
  className: 'definition-title'

  initialize: ({title, titleClassName}) ->
    @title = title
    @titleClassName = titleClassName

  render: ->
    @$el.html(@template(className: @titleClassName, title: @title))
    @
